import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import Button from "../ui/button/Button";
import { useTranslation } from "react-i18next";
import { IOSSwitch } from "../../pages/fleetAndRoute/components/IOSSwitch";
import { Box, Typography } from "@mui/material";
interface ISidebarProps {
  isOpen?: boolean;
  callbackCloseSidebar: () => void;
}

const SidebarAddAssociations: React.FC<ISidebarProps> = ({
  isOpen = false,
  callbackCloseSidebar,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    phone: "",
    pIva: "",
    email: "",
  });

  const [defaultStatus,setDefaultStatus]= useState(true);

  const [hasError, setHasError] = useState(false);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const addDriver = async () => {
    setSubmitted(true);
  }; 


  

  return (
    <aside
      className={
        "flex flex-col transition z-10 fixed right-0 top-0 h-[100dvh] w-screen md:w-[520px] bg-white overflow-auto hide-scrollbar" +
        (isOpen === true
          ? " translate-x-0 sidebar-shadow"
          : " translate-x-[100%]")
      }
    >
      <div className="shrink-0 h-[88px] px-[30px] pt-[32px] pb-[24px] border-b flex justify-between items-center">
        <div className="text-lg font-bold leading-[21.6px]">
          {t("common.sidebars.addDriver.heading")}
        </div>
        <div onClick={callbackCloseSidebar} className="cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>

      {/* MAIN CONTENT OF SIDEBAR */}
      <div className=" overflow-auto px-[30px] ">
        <h3 className="text-[18px] font-semibold mb-6 mt-6">
          {" "}
          {t("common.sidebars.addDriver.paragraph")}
        </h3>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="font-semibold text-sm text-red uppercase leading-[17px] block mb-[5px]">
              {t("common.sidebars.addDriver.name")} *
            </label>
            {submitted ? (
              <p>{formData.name}</p>
            ) : (
              <input
                type="text"
                name="name"
                placeholder={t("common.sidebars.addDriver.addName") || ""}
                value={formData.name}
                onChange={handleChange}
                className={`input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full ${
                  hasError && !formData.name ? "border-red" : ""
                }`}
              />
            )}
          </div>
          <div>
            <label className="font-semibold text-sm text-red uppercase leading-[17px] block mb-[5px]">
              {t("common.sidebars.addDriver.surname")} *
            </label>
            {submitted ? (
              <p>{formData.surname}</p>
            ) : (
              <input
                type="text"
                name="surname"
                placeholder={t("common.sidebars.addDriver.addSurname") || ""}
                value={formData.surname}
                onChange={handleChange}
                className={`input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full ${
                  hasError && !formData.surname ? "border-red" : ""
                }`}
              />
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {/* Campo Telefono */}
          <div>
            <label className="font-semibold text-sm text-red uppercase leading-[17px] block mt-4 mb-[5px]">
              {t("common.sidebars.addDriver.phone")} *
            </label>
            {submitted ? (
              <p>{formData.phone}</p>
            ) : (
              <input
                type="text"
                name="phone"
                placeholder={t("common.sidebars.addDriver.addPhone") || ""}
                value={formData.phone}
                onChange={handleChange}
                className={`input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full ${
                  hasError && !formData.phone ? "border-red" : ""
                }`}
              />
            )}
          </div>

          {/* Campo P.IVA */}
          <div>
            <label className="font-semibold text-sm text-red uppercase leading-[17px] block mt-4 mb-[5px]">
              {t("common.sidebars.addDriver.pIva")} *
            </label>
            {submitted ? (
              <p>{formData.pIva}</p>
            ) : (
              <input
                type="text"
                name="pIva" // Corretto da "p.Iva" a "pIva" per evitare problemi
                placeholder={t("common.sidebars.addDriver.addPIva") || ""}
                value={formData.pIva}
                onChange={handleChange}
                className={`input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full ${
                  hasError && !formData.pIva ? "border-red" : ""
                }`}
              />
            )}
          </div>
        </div>

        <label className="font-semibold text-sm text-red uppercase leading-[17px] block mt-4 mb-[5px]">
          {t("common.sidebars.addDriver.email")} *
        </label>
        {submitted ? (
          <p>{formData.email}</p>
        ) : (
          <input
            type="email"
            name="email"
            placeholder={t("common.sidebars.addDriver.addEmail") || ""}
            value={formData.email}
            onChange={handleChange}
            className={`input-text leading-[18px] text-black text-[15px] bg-white border border-[#6F6F6F] rounded-[8px] p-[10px] w-full ${
              hasError && !formData.email ? "border-red" : ""
            }`}
          />
        )}
        {hasError && formData.email && (
          <p className="text-red text-sm mt-1">
            {t("common.sidebars.addDriver.invalidEmail")}
          </p>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Box
            sx={{
              columnGap: "8px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "14px",
                color: "#CF0A2C",
              }}
            >
              {t("common.sidebars.addDriver.driverStatus")}:
            </Typography>
            <IOSSwitch defaultChecked={defaultStatus} />
          </Box>
        </Box>
      </div>

      <div
        className="shrink-0 py-6 px-[30px]  border-t"
        style={{ marginTop: "24px" }}
      >
        <p> * {t("common.sidebars.addDriver.info")}</p>
      </div>

      <div className="shrink-0 py-6 px-[30px] text-right ">
        <Button callback={addDriver} loading={loading}>
          {t("common.sidebars.addDriver.button")}
        </Button>
      </div>
    </aside>
  );
};

export default React.memo(SidebarAddAssociations);
